import { TypeStickyCartNavWithoutUnresolvableLinksResponse } from '@/contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import StickyCartNav from './StickyNav'

const ContentfulStickyCartNav = withContentful<TypeStickyCartNavWithoutUnresolvableLinksResponse['fields']>(
  StickyCartNav,
  {
    defaultValuesCart: (props) => {
      return {
        primaryButtonHrefWithToggleOff: props.fields.primaryButtonHrefWithToggleOff,
        primaryButtonHrefWithToggleOn: props.fields.primaryButtonHrefWithToggleOn,
        ribbonTextWithToggleOn: props.fields.ribbonTextWithToggleOn,
        ribbonTextWithToggleOff: props.fields.ribbonTextWithToggleOff,
      }
    },
    fiveYearValues: (props) => {
      return {
        primaryButtonHrefFiveYearWithToggleOn: props.fields.primaryButtonHrefFiveYearWithToggleOn,
        primaryButtonHrefFiveYearWithToggleOff: props.fields.primaryButtonHrefFiveYearWithToggleOff,
        ribbonTextFiveYearTermToggleOn: props.fields.ribbonTextFiveYearTermToggleOn,
        ribbonTextFiveYearTermToggleOff: props.fields.ribbonTextFiveYearTermToggleOff,
      }
    },
    threeYearValues: (props) => {
      return {
        primaryButtonHrefThreeYearWithToggleOn: props.fields.primaryButtonHrefThreeYearWithToggleOn,
        primaryButtonHrefThreeYearWithToggleOff: props.fields.primaryButtonHrefThreeYearWithToggleOff,
        ribbonTextThreeYearTermToggleOn: props.fields.ribbonTextThreeYearTermToggleOn,
        ribbonTextThreeYearTermToggleOff: props.fields.ribbonTextThreeYearTermToggleOff,
      }
    },
    navPrice: (props) => {
      return {
        priceFiveYearWithToggleOff: props.fields.stickyCartPrice.fields.priceFiveYearWithToggleOff,
        priceFiveYearWithToggleOn: props.fields.stickyCartPrice.fields.priceFiveYearWithToggleOn,
        priceThreeYearWithToggleOff: props.fields.stickyCartPrice.fields.priceThreeYearWithToggleOff,
        priceThreeYearWithToggleOn: props.fields.stickyCartPrice.fields.priceThreeYearWithToggleOn,
        priceWithToggleOff: props.fields.stickyCartPrice.fields.priceWithToggleOff,
        priceWithToggleOn: props.fields.stickyCartPrice.fields.priceWithToggleOn,
        stickyCartPriceSignDirection: props.fields.stickyCartPrice.fields.stickyCartPriceSignDirection,
        stickyCartPriceSize: props.fields.stickyCartPrice.fields.stickyCartPriceSize,
        stickyCartRateText: props.fields.stickyCartPrice.fields.stickyCartRateText,
        strikePriceFiveYearWithToggleOff: props.fields.stickyCartPrice.fields.strikePriceFiveYearWithToggleOff,
        strikePriceFiveYearWithToggleOn: props.fields.stickyCartPrice.fields.strikePriceFiveYearWithToggleOn,
        strikePriceRateText: props.fields.stickyCartPrice.fields.strikePriceRateText,
        strikePriceSignDirection: props.fields.stickyCartPrice.fields.strikePriceSignDirection,
        strikePriceSize: props.fields.stickyCartPrice.fields.strikePriceSize,
        strikePriceThreeYearWithToggleOff: props.fields.stickyCartPrice.fields.strikePriceThreeYearWithToggleOff,
        strikePriceThreeYearWithToggleOn: props.fields.stickyCartPrice.fields.strikePriceThreeYearWithToggleOn,
        strikePriceWithToggleOff: props.fields.stickyCartPrice.fields.strikePriceWithToggleOff,
        strikePriceWithToggleOn: props.fields.stickyCartPrice.fields.strikePriceWithToggleOn,
      }
    },
  }
)

export default ContentfulStickyCartNav
